import * as React from "react"
import { DateRangePickerSeeker, disabledBeforeToday } from "@ui-seeker/core"
import {useRepricingFormData} from "../../@hooks";
import {useEffect} from "react";



export default function RepricingFormDateRange({ enabled }) {
	const { scheduleDateStart, scheduleDateEnd, handleChangeScheduleTime } = useRepricingFormData()

	useEffect(() => {
		if (!enabled)
			handleChangeScheduleTime(null)
	}, [enabled])

	if (!enabled)
		return <></>

	return <DateRangePickerSeeker
		cleanable
		shouldDisableDate={disabledBeforeToday()}
		placement="auto"
		value={[scheduleDateStart, scheduleDateEnd]}
		onChange={handleChangeScheduleTime}
	/>
}